import React from "react";

// Responsive breakpoint: narrow = width ≤ 719px, wide = width ≥ 720px.
// Matches the two UI modes used across the rebrand.
//
// Usage:
//   const isNarrow = useIsNarrow();
//   const perPage = isNarrow ? 1 : 4;

const NARROW_QUERY = "(max-width: 719px)";

export default function useIsNarrow() {
  const [narrow, setNarrow] = React.useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(NARROW_QUERY).matches;
  });

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(NARROW_QUERY);
    const onChange = (e) => setNarrow(e.matches);

    // Modern browsers
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    // Safari < 14
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  return narrow;
}
